import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSession } from '@brighthub/uisession';
import { Conversation, CopilotFacadeService } from '@brighthub/copilot';
import { ConversationService } from '../conversation.service';
import { Router } from '@angular/router';
import { Avatar } from 'primeng/avatar';
import { ButtonDirective } from 'primeng/button';
import { CapitalizeFirstPipe } from '@brighthub/helpers';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'lib-conversation-info',
  imports: [CommonModule, Avatar, ButtonDirective, CapitalizeFirstPipe, Tooltip],
  templateUrl: './conversation-info.component.html',
  styleUrl: './conversation-info.component.scss',
})
export class ConversationInfoComponent {
  @Input() conversationInfo!: UiSession;
  @Input() collapsed = false;
  @Input() selected = false;
  @Input() highlight: boolean | undefined = false;
  @Input() type= 'conversation';
  @Output() conversationClicked = new EventEmitter<UiSession>();

  get initials(): string {
    const { firstName, lastName } = this.conversationInfo.subjectData;
    return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
  }

  get employee(): string {
    let firstName = '';
    let lastName = '';
    if (this.conversationInfo.oktaUser) {
      firstName = this.conversationInfo.oktaUser.firstName;
      lastName = this.conversationInfo.oktaUser.lastName;
    }
    return `${firstName} ${lastName}`;
  }

  private _router = inject(Router);
  private _conversationService = inject(ConversationService);

  onClick() {
    // if (this.conversationClicked.observed) {
      this.conversationClicked.emit(this.conversationInfo);
    // } else {
    //   this._selectConversation();
    // }
  }

}
